export const INSTALLER = 'Installer';
export const ADMINISTRATOR = 'Administrator';
